import { ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';

const RESERVED_SEGMENTS = new Set(['p']);

/**
 * Resolve a organização a partir do contexto de rota do Angular,
 * sem depender de `location.pathname` (que pode conter segmentos
 * transitórios como `/p/:token`).
 *
 * Prioridade:
 *  1. `route.params['organizacao']`
 *  2. `route.parent?.params?.['organizacao']`
 *  3. Primeiro segmento de `state.url` (se não for reservado)
 *  4. `sessionStorage.getItem('router')`
 */
export function resolveOrganizacao(
  route: ActivatedRouteSnapshot | null,
  state?: RouterStateSnapshot | null
): string {
  const fromParams =
    route?.params?.['organizacao'] ||
    route?.parent?.params?.['organizacao'] ||
    '';

  if (fromParams) {
    return fromParams;
  }

  if (state?.url) {
    const segment = state.url.split('/')[1]?.split('?')[0] || '';
    if (segment && !RESERVED_SEGMENTS.has(segment)) {
      return segment;
    }
  }

  return sessionStorage.getItem('router') || '';
}

/**
 * Verifica se um segmento de URL é reservado (não representa organização).
 */
export function isReservedSegment(segment: string): boolean {
  return RESERVED_SEGMENTS.has(segment);
}
